module.exports = __webpack_public_path__ + "static/3-dee91328880cf1f91b84eebe479183ba.jpg";